import React from 'react'
import { Fade } from "react-awesome-reveal";
import ContactForm from '../ContactFrom/ContactForm'
/* eslint-disable no-unused-vars */

const ContactSection = () => {
    return (
        <section id="contact" className="contact-section-modern">
            {/* Decorative orbs */}
            <div style={{
                position: 'absolute',
                top: '-100px',
                right: '-100px',
                width: '400px',
                height: '400px',
                background: 'radial-gradient(circle, rgba(102, 126, 234, 0.15) 0%, transparent 70%)',
                borderRadius: '50%',
                pointerEvents: 'none'
            }}></div>
            <div style={{
                position: 'absolute',
                bottom: '-100px',
                left: '-100px',
                width: '300px',
                height: '300px',
                background: 'radial-gradient(circle, rgba(118, 75, 162, 0.15) 0%, transparent 70%)',
                borderRadius: '50%',
                pointerEvents: 'none'
            }}></div>

            <div className="container" style={{ position: 'relative', zIndex: 1 }}>
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-8">
                        {/* Section Header */}
                        <div className="text-center" style={{ marginBottom: '50px' }}>
                            <Fade direction="down" triggerOnce={true} duration={800}>
                                <span className="section-badge" style={{
                                    background: 'rgba(102, 126, 234, 0.2)',
                                    borderColor: 'rgba(102, 126, 234, 0.3)',
                                    color: '#a5b4fc'
                                }}>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                        <path d="M21 5L12 14L3 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M3 5H21V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                    &nbsp; Contact Us
                                </span>
                            </Fade>
                            <Fade direction="down" triggerOnce={true} duration={1000} delay={100}>
                                <h2 style={{
                                    fontSize: '2.5rem',
                                    fontWeight: '800',
                                    color: 'white',
                                    marginBottom: '16px',
                                    marginTop: '20px'
                                }}>
                                    Let's Start a Conversation
                                </h2>
                            </Fade>
                            <Fade direction="down" triggerOnce={true} duration={1000} delay={200}>
                                <p style={{
                                    fontSize: '1.125rem',
                                    color: 'rgba(255, 255, 255, 0.7)',
                                    maxWidth: '500px',
                                    margin: '0 auto'
                                }}>
                                    Ready to optimize your SaaS spend? Get in touch and we'll help you get started.
                                </p>
                            </Fade>
                        </div>

                        {/* Contact Form */}
                        <Fade direction="up" triggerOnce={true} duration={1000} delay={300}>
                            <div className="contact-form-modern">
                                <ContactForm />
                            </div>
                        </Fade>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ContactSection;
